import { addUserKpi, deleteUserKpi, getAllKpis, getUserFilteredKpis, getUserKpis, reorderKpis, getWidgetsData } from './dashboard.action';

export { dashboardReducer } from './dashboard.reducer';
export { watchDashboard } from './dashboard.saga';

export const dashboardActions = {
    /** Analytics */
    getUserFilteredKpis,
    getAllKpis,
    getUserKpis,
    reorderKpis,
    deleteUserKpi,
    addUserKpi,

    getWidgetsData,
    /** End */
};
